<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.jpg" alt="" />
      <span class="link" @click="openChat()">諮詢</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ActivityBox',
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['accountInfo', 'userInfo', 'token', 'refreshToken']),

    // 是否已登入狀態
    isLogined() {
      return this.uuid ? true : false;
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    }
  },
  watch: {},
  methods: {
    openChat() {
      if (this.userInfo) {
        this.$util.openChatWindow(this.uuid, '666666');
      } else {
        this.$util.Login();
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #d1aebd;
  overflow: auto;
  text-align: center;
  font-size: 0;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .link {
      text-decoration: underline;
      position: absolute;
      top: 3292px;
      right: 227px;
      color: #7b6071;
      font-size: 27px;
    }
  }
}
</style>
